import { mediaQuery, pxToRem } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

import { breakpoint } from 'src/styles/dontgiftguide.styles';
import { dggTheme } from '../../../../styles/dggTheme';

const { colors, fonts } = dggTheme;

export const contentBackground = css`
  background-color: var(--backgroundColor);
`;

export const content = css`
  margin: 0 auto;
  width: ${pxToRem(360)};
  font-family: ${fonts.PRIMARY_REGULAR.familyWithFallbacks};
  font-weight: ${fonts.PRIMARY_REGULAR.weight};

  ${mediaQuery(
    { min: breakpoint },
    css`
      width: ${pxToRem(breakpoint)};
    `,
  )}
`;

export const copyLight = css`
  color: ${colors.neutralWhite};
`;

export const copyDark = css`
  color: ${colors.parisM};
`;
